import { render, staticRenderFns } from "./myMessage.vue?vue&type=template&id=b545021c&scoped=true"
import script from "./myMessage.vue?vue&type=script&lang=js"
export * from "./myMessage.vue?vue&type=script&lang=js"
import style0 from "./myMessage.vue?vue&type=style&index=0&id=b545021c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b545021c",
  null
  
)

export default component.exports